import { App } from 'antd'
import { useEffect } from 'react'
import { setToastInstance } from './toast'

export { toast } from './toast'

export function ToastBridge() {
  const { notification } = App.useApp()
  useEffect(() => {
    setToastInstance(notification)
    return () => {
      setToastInstance(null)
    }
  }, [notification])
  return null
}
